import { atom } from 'recoil';

export const facilitySearchAtom = atom<string>({
  key: `FacilityListSearchValueAtom`,
  default: ''
});
